<template>
    <content-view
        class="accountList"
    >
        <tab-components-vue @tabNumChange="tabNumChange"></tab-components-vue>

        <Sortingcenter v-if="currentNum == 0"></Sortingcenter>
        <Residentcenter v-if="currentNum == 1"></Residentcenter>
        <Toxiccenter v-if="currentNum == 2"></Toxiccenter>
    </content-view>
</template>
<script>
    import Sortingcenter from './components/sortingcenter.vue';
    import Residentcenter from './components/residentcenter.vue';
    import Toxiccenter from "./components/harmfulcenter.vue";
    import tabComponentsVue from '../../components/common/tab.components.vue';

    export default {
        name: "orderMergeList",
        data() {
            return {
                tabList: [{
                    name: "临安分拣中心",
                    id: "0"
                },{
                    name: "临安居民回收资源",
                    id: "1"
                },{
                    name: "临安有毒有害回收信息",
                    id: "2"
                }],
                visible: false,
                centerId: "",
                statusList: [
                    {
                        name: '禁用',
                        value: "0"
                    },
                    {
                        name: '正常',
                        value: "1"
                    }
                ],
                modalWidth: 434,
                visible: false,
                confirmLoading: false,
                block_id: "",
                // tabList: [{
                //     name: "临安有毒有害回收信息",
                //     id: "2"
                // }],
                currentNum: 0
            };
        },
        components: {
            tabComponentsVue,
            Sortingcenter,
            Residentcenter,
            Toxiccenter
        },
        computed: {},
        methods: {
            // tab切换点击
            tabClick(data, index) {
                this.currentNum = index;
            },
            // 接受组件的值
            tabNumChange(val) {
                this.currentNum = val;
            }
        },
        mounted() {
        },
        created() {
            // if(this.$route.query.tonglu){
            //     let value = {
            //         login: "0571311500",
            //         passwd: "123456"
            //     }
            //     this.$api.login
            //         .login(value)
            //         .then(res => {
            //             if(res.code > 0){
            //                 this.$message.error(res.msg);
            //                 // window.location.reload();
            //             }else{
            //                 localStorage.user = JSON.stringify(res.data);
            //                 localStorage._token = res.data.token;
                            
            //             }
            //         })
            //         .catch(error => {
            //             console.log(error);
            //         })
            //         .finally(() =>{});
            // }
            
        },
        watch: {
            
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss">
    .wrap-cont-cover {
        flex: unset;
    }
    .wrap-container {
        flex: unset;
    }
    .wrap-container > div {
        flex: unset;
    }
    .accountList {
         &-tab {
            display: flex;
            &-list {
                width: 253px;
                height: 134px;
                background: url(../../assets/tabunlight.png) no-repeat;
                background-size: 100% 100%;
                color: #363E51;
                cursor: pointer;
                .content {
                    margin-top: 20px;
                    margin-left: 30px;
                    font-size: 14px;
                    & > div:nth-child(1) {
                        font-weight: bold;
                    }
                    & > div:nth-child(2) {
                       font-size: 12px;
                       margin-top: 10px;
                    }
                }
            }
            .active {
                color: #ffffff !important;
                background: url(../../assets/tablight.png) no-repeat !important;
            }
        }
    }
</style>
